import { IoMdTrash } from 'react-icons/io';

import useDeleteFromCart from '../../../hooks/useDeleteFromCart';
import ButtonDelete from '../../generic/button/ButtonDelete';

const CartElementDeleteAction = ({ cartOrderId, getItemIdsToDelete, position, alignItems, blockActions, ...props }) => {
  const { setItemIdsToDelete, deleteConfirmMessage, isDeleteConfirmed, setIsDeleteConfirmed } = useDeleteFromCart(cartOrderId);

  const handleClick = () => {
    setItemIdsToDelete(getItemIdsToDelete());
  };

  return (
    <ButtonDelete
      onClick={handleClick}
      position={position}
      alignItems={alignItems}
      className="CartDelete"
      showAlert
      blockActions={blockActions}
      defaultIcon={IoMdTrash}
      deleteConfirmMessage={deleteConfirmMessage}
      isDeleteConfirmed={isDeleteConfirmed}
      setIsDeleteConfirmed={setIsDeleteConfirmed}
      {...props}
    />
  );
};

export default CartElementDeleteAction;
